<template>
    <Dialog 
        v-model:visible="visible" 
        modal 
        :header="translationHandler.translate('loading', 'ucfirst') + '...'" 
        :style="{ width: '25rem' }"
        :closable="false"
        :draggable="false"
    >
        <ProgressSpinner 
            :style="{'width': '50px','height': '50px'}"
            strokeWidth="8" 
            fill="transparent" 
            animationDuration=".9s"
            aria-label="Custom ProgressSpinner"
        />
    </Dialog>
</template>

<script setup>
    import Dialog from "primevue/dialog";
    import ProgressSpinner from "primevue/progressspinner";
    import translationHandler from "@/composables/handlers/TranslationHandler";
    import { ref, defineProps, onMounted, watch } from "vue";

    let visible = ref(true);
    const props = defineProps({
        visible: {
            type: Boolean,
            default: false,
        }
    });

    onMounted(() => {
        visible.value = props.visible;
    });

    watch(props.visible, (newValue) => {
        visible.value = newValue;
    });
</script>
